import { render } from "./VoucherTransactionsList.vue?vue&type=template&id=1067a2a3&scoped=true"
import script from "./VoucherTransactionsList.vue?vue&type=script&lang=js"
export * from "./VoucherTransactionsList.vue?vue&type=script&lang=js"

import "./VoucherTransactionsList.vue?vue&type=style&index=0&id=1067a2a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1067a2a3"]])

export default __exports__